const ClaimMethod = {
  AutoCashIn: "auto-cashin",
  SeedInVoucherTray: "seed-in-voucher-tray",
};

export default ClaimMethod;
